import React from "react";
import PlaystoreIMG from "../../images/playstore.png";
import BgIMG from "../../images/imagebg2.png";
import ApplestoreIMG from "../../images/appstore.svg";
import { useTranslation } from "react-i18next";

import {
  HeroContainer,
  HeroBg,
  ImageBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  HeroBtn,
  HeroImgAppstore,
  HeroImgPlaystore,
} from "./HeroElements";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <HeroContainer>
      <HeroBg>
        <ImageBg src={BgIMG} />
        {/* <VideoBg autoPlay loop src={Video} type="video/mp4" /> */}
      </HeroBg>

      <HeroContent>
  
        <HeroH1>VIVARAM</HeroH1>
        <HeroP>{t('heroP.txt')}</HeroP>

        <HeroBtnWrapper>
          <HeroBtn>
            <HeroImgPlaystore src={PlaystoreIMG} alt="" />
          </HeroBtn>
          <HeroBtn>
            <HeroImgAppstore src={ApplestoreIMG} alt="" />
          </HeroBtn>
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;
